import { render, staticRenderFns } from "./SentProductRequestOverview.vue?vue&type=template&id=505d9c06&"
import script from "./SentProductRequestOverview.vue?vue&type=script&lang=js&"
export * from "./SentProductRequestOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports